import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import IntersectObserver from '@/components/common/IntersectObserver';
import { Toaster } from '@/components/ui/sonner';
import { ThemeProvider } from './components/theme-provider';
import { UnlockProvider } from './contexts/UnlockContext';
import { BrowserProvider } from './contexts/BrowserContext';
import { AuthProvider } from './contexts/AuthContext';
import { LanguageProvider } from './contexts/LanguageContext';
import { RouteGuard } from './components/common/RouteGuard';
import { AIAssistant } from './components/AIAssistant';
import { routes } from './routes';

const App: React.FC = () => {
  return (
    <ThemeProvider defaultTheme="system" storageKey="vx-theme">
      <LanguageProvider>
        <AuthProvider>
          <UnlockProvider>
            <BrowserProvider>
              <BrowserRouter>
                <IntersectObserver />
                <RouteGuard>
                  <div className="flex flex-col min-h-screen">
                    <main className="flex-grow">
                      <Routes>
                      {routes.map((route, index) => (
                        <Route
                          key={index}
                          path={route.path}
                          element={route.element}
                        />
                      ))}
                      <Route path="*" element={<Navigate to="/" replace />} />
                      </Routes>
                    </main>
                  </div>
                  <AIAssistant />
                  <Toaster />
                </RouteGuard>
              </BrowserRouter>
            </BrowserProvider>
          </UnlockProvider>
        </AuthProvider>
      </LanguageProvider>
    </ThemeProvider>
  );
};

export default App;
